import * as types from './constants';

export const getDataSupervisor = (data, page, size) => {
    return ({
        type: types.GET_DATA_SUPERVISOR,
        payload: data,
        loading: data?.length <= 0 ? true : false,
        page: page,
        size: size
    })
}

export const resetLoading = () => ({
    type: types.RESET_LOADING
})

export const submitSucceed = (message) => ({
    type: types.SUBMIT_SUCCEED,
    payload: message
});

export const submitFailed = (message) => ({
    type: types.SUBMIT_FAILED,
    payload: message
});

export function openNewDialog()
{
    return {
        type: types.OPEN_NEW_DIALOG
    }
}

export function closeNewDialog()
{
    return {
        type: types.CLOSE_NEW_DIALOG
    }
}

export const resetMessage = () => ({
    type: types.RESET_MESSAGE
})

export function filterSupervisor(data) {
    return {
        type: types.FILTER_SUPERVISOR,
        formData: data,
    }
}

export function loadSupervisorByFilter(data) {
    return {
        type: types.LOAD_SUPERVISOR_BY_FILTER,
        payload: data,
    }
}

export function editSupervisor(data, id) {
    return {
        type: types.EDIT_SUPERVISOR,
        formData: data,
        id: id
    }
}

export function deleteSupervisor(id) {
    return {
        type: types.DELETE_SUPERVISOR,
        id: id,
    }
}
